import initThemeToggle    from "./themeToggle.js";
import initResumeDropdown from "./resumeDropdown.js";

// ── Certificate image viewer (same lightbox as the Projects section) ──
function initCertLightbox() {
  let lb = document.getElementById("exp-lightbox");
  if (!lb) {
    lb = document.createElement("div");
    lb.id = "exp-lightbox";
    lb.innerHTML = `
      <div id="exp-lightbox-overlay"></div>
      <button id="exp-lightbox-close" aria-label="Close">✕</button>
      <button id="exp-lightbox-prev" aria-label="Previous image">&lsaquo;</button>
      <button id="exp-lightbox-next" aria-label="Next image">&rsaquo;</button>
      <div id="exp-lightbox-content">
        <img id="exp-lightbox-img" src="about:blank" alt="" />
        <span id="exp-lightbox-count"></span>
      </div>`;
    document.body.appendChild(lb);
  }

  const lbImg   = lb.querySelector("#exp-lightbox-img");
  const lbCount = lb.querySelector("#exp-lightbox-count");
  const cards   = Array.from(document.querySelectorAll(".cert-card"));
  let idx = 0;

  const show = (i) => {
    idx = (i + cards.length) % cards.length;
    const img = cards[idx].querySelector("img");
    lbImg.src = img.currentSrc || img.src;
    lbCount.textContent = cards.length > 1 ? `${idx + 1} / ${cards.length}` : "";
  };
  const open  = (i) => { show(i); lb.classList.add("active"); document.body.style.overflow = "hidden"; };
  const close = () => { lb.classList.remove("active"); document.body.style.overflow = ""; };

  cards.forEach((card, i) => {
    card.addEventListener("click", () => open(i));
    card.addEventListener("keydown", (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(i); } });
  });
  lb.querySelector("#exp-lightbox-close").addEventListener("click", close);
  lb.querySelector("#exp-lightbox-overlay").addEventListener("click", close);
  lb.querySelector("#exp-lightbox-prev").addEventListener("click", () => show(idx - 1));
  lb.querySelector("#exp-lightbox-next").addEventListener("click", () => show(idx + 1));
  document.addEventListener("keydown", (e) => {
    if (!lb.classList.contains("active")) return;
    if (e.key === "Escape") close();
    if (e.key === "ArrowLeft") show(idx - 1);
    if (e.key === "ArrowRight") show(idx + 1);
  });
}

// ── Fluid lens cursor (desktop only) ──────────────────────────────────
function initLens() {
  const lens = document.getElementById("fluid-lens");
  if (!lens) return;
  if (window.innerWidth <= 1024) { lens.style.display = "none"; return; }

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight * 0.22;
  let lensX = mouseX;
  let lensY = mouseY;

  document.addEventListener("mousemove", (e) => { mouseX = e.clientX; mouseY = e.clientY; });

  (function animateLens() {
    lensX += (mouseX - lensX) * 0.3;
    lensY += (mouseY - lensY) * 0.3;
    lens.style.left = lensX + "px";
    lens.style.top  = lensY + "px";
    requestAnimationFrame(animateLens);
  })();

  document.querySelectorAll("a, button, .cert-card").forEach((el) => {
    el.addEventListener("mouseenter", () => lens.classList.add("hovering"));
    el.addEventListener("mouseleave", () => lens.classList.remove("hovering"));
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initCertLightbox();   // first, so nothing below can stop it
  initThemeToggle();
  initResumeDropdown();
  initLens();

  const header = document.getElementById("site-header");
  const update = () => header && header.classList.toggle("is-scrolled", window.scrollY > 80);
  update();
  window.addEventListener("scroll", update, { passive: true });
});
